import { Button, Dropdown, Menu } from "antd";
import { IoIosArrowDown } from "react-icons/io";

const CustomDropDown = ({ items, text, filterMenu }) => {
  return (
    <Dropdown
      trigger="click"
      overlay={
        <Menu>
          {filterMenu}
          {items?.map((item) => (
            <Menu.Item key={item.key}>{item.label}</Menu.Item>
          ))}
        </Menu>
      }
      placement="bottom"
      arrow
    >
      <Button
        className={`status-filter-btn ${text === "Location" && "!tw-w-64"} ${
          text === "Location" && "!tw-w-64"
        } ${!filterMenu && "!tw-w-64"}`}
      >
        <p
          className={`tw-w-28 tw-truncate !tw-mb-0 ${
            text === "Location" && "!tw-w-52 tw-text-left"
          } ${text === "Location" && "!tw-w-52 tw-text-left"} ${
            !filterMenu && "!tw-w-64 tw-text-left"
          }`}
        >
          {text}
        </p>
        <IoIosArrowDown />
      </Button>
    </Dropdown>
  );
};

export default CustomDropDown;
